import { render, staticRenderFns } from "./formSquarepay.vue?vue&type=template&id=913d806e&scoped=true"
import script from "./formSquarepay.vue?vue&type=script&lang=js"
export * from "./formSquarepay.vue?vue&type=script&lang=js"
import style0 from "./formSquarepay.vue?vue&type=style&index=0&id=913d806e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913d806e",
  null
  
)

export default component.exports